/**
 * BRXSessionClients
 *
 * Thin DOM/client helpers for surfaces that consume window.BRXSession.
 *
 * Usage:
 * - syncSelectionToSession(root) — push the current select value into session
 * - openSelectionDrawer() — trigger the selection drawer to open
 * - syncPromoInputToSession(inputEl) — push a promo input value into session
 */
(function () {
    /**
     * Trigger the selection drawer to open by clicking its registered trigger buttons.
     */
    function openSelectionDrawer() {
        document.querySelectorAll('[data-brx-drawer-trigger="selection"]').forEach((btn) => btn.click());
    }

    /**
     * Read the current selection payload from a product root element.
     * Expects a [data-brx-product-select] select inside root with options
     * carrying data-med-id and data-cc-product-id attributes.
     * Returns null if no option is found.
     */
    function getSelectedPayloadFromSelect(root) {
        const select = root.querySelector('[data-brx-product-select]');
        const option = select?.options?.[select.selectedIndex];
        if (!option) return null;

        return {
            groupKey: root.getAttribute('data-group-key') || null,
            productHandle: root.getAttribute('data-product-handle') || null,
            variantId: option.value || null,
            medId: option.getAttribute('data-med-id') || null,
            ccProductId: option.getAttribute('data-cc-product-id') || null
        };
    }

    /**
     * Read the current select state from a product root element and push it
     * into BRXSession as a 'surface' selection.
     */
    function syncSelectionToSession(root, session = window.BRXSession) {
        const payload = getSelectedPayloadFromSelect(root);
        if (!payload || !session?.setSelection) return;
        session.setSelection(payload, 'surface');
    }

    /**
     * Push the current value of a promo code input element into BRXSession.
     * Clears the promo code if the input is empty.
     */
    function syncPromoInputToSession(inputEl, session = window.BRXSession) {
        if (!inputEl || !session?.setPromoCode) return;
        const value = inputEl.value?.trim();
        if (value) {
            session.setPromoCode(value);
        } else {
            session.clearPromoCode?.();
        }
    }

    window.BRXSessionClients = {
        openSelectionDrawer,
        getSelectedPayloadFromSelect,
        syncSelectionToSession,
        syncPromoInputToSession
    };
})();
